import { computed, ref } from 'vue'
import { DataRow } from '../../types/components/data-rendering'

export const useCheckboxes = (rows: DataRow[], props: any) => {
  const checkedItems = ref<(boolean | null)[]>([])

  const mapRowsToCheckedItems = () => {
    const data: boolean[] = []
    for (let index = 0; index < rows.length; index++) {
      data[index] = false
    }
    checkedItems.value = data
  }
  const allChecked = computed(() => {
    const data: any = []
    for (let index = 0; index < checkedItems.value.length; index++) {
      if (showCheckbox(rows[index])) data.push(checkedItems.value[index])
      else data.push(null)
    }

    //todo can speed up and break for loop when we find first false and true value
    //so start loop, then if there's a false, it can either be null or false,
    //then moment there's a true we stop loop
    if (data.length < 1) return false
    else if (data.includes(false) && data.includes(true)) return null
    else if (data.includes(false)) return false
    else if (checkedItems.value.includes(null)) return false
    else return true
  })
  const toggleAllCheckboxes = () => {
    if (!allChecked.value) {
      checkedItems.value = rows.map((item, index) => {
        if (showCheckbox(rows[index])) return true
        else return false
      })
    } else {
      checkedItems.value = rows.map((item, index) => {
        if (showCheckbox(rows[index])) return false
        else return false
      })
    }
  }
  const showCheckbox = (row: DataRow) => {
    if (!props.checkbox || !props.checkbox.checklist) {
      return false
    } else if (typeof props.checkbox.checklist === 'function') {
      return props.checkbox!.checklist(row)
    } else if (typeof props.checkbox.checklist === 'boolean') {
      return props.checkbox!.checklist === true
    }
  }
  const unCheckAll = () => {
    checkedItems.value = rows.map(() => {
      return false
    })
  }
  return {
    checkedItems,
    mapRowsToCheckedItems,
    allChecked,
    toggleAllCheckboxes,
    unCheckAll,
    showCheckbox,
  }
}
